import React from 'react'
import { Box, Breadcrumbs, Collapse, Link, useMediaQuery } from '@material-ui/core'
import { breadcumbsStyle } from './layout.style'
import { breadcrumbsStore } from '~/stores/breadcrumb.store'
import { NavigateNext } from '@material-ui/icons'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { HomeFullSvg } from '../icons'
import { PATHS } from '~/common/constants'
import { Typography } from '../typography'
import { observer } from '~/common/mobx.decorator'

export const Breadcumbs = observer(() => {
	const { breadcrumItems } = breadcrumbsStore
	const smDown = useMediaQuery((theme) => theme.breakpoints.down('sm'))
	const { t } = useTranslation()
	return (
		<Collapse in={breadcrumItems.length !== 0}>
			<Box css={breadcumbsStyle} paddingX={smDown ? '24px' : '10%'} paddingY="10px">
				<Breadcrumbs separator={<NavigateNext fontSize="small" />}>
					<Link className="root-item" component={RouterLink} to={PATHS.care.home}>
						<HomeFullSvg style={{ marginRight: '12px' }} />
						<Typography className="text">{t('HOME')}</Typography>
					</Link>
					{breadcrumItems.map(({ label, href, onClick }, index) => (
						<Link variant="body2" key={index} component={href ? RouterLink : undefined} to={href} onClick={onClick} className="member-item">
							<Typography className="text">{t(label)}</Typography>
						</Link>
					))}
				</Breadcrumbs>
			</Box>
		</Collapse>
	)
})
